import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const OwnersQuery = graphql(/* GraphQL */ `
  query owners($locationId: UUID!, $offset: Int, $limit: Int) {
    owners(locationId: $locationId, offset: $offset, limit: $limit) {
      ...OwnersPaged
    }
  }
`);
